const Header = () => {
    return (
        <header className="m-5 flex justify-center border-b">
            <img className="w-11 h-11 rotate-12 mr-2 animate-wiggle" src="./waffle.png" alt="wordle waffle logo" />
            <h1 className="my-2 text-4xl"> Waffle </h1>
        </header>
    )
}

export default Header; 